<template>
  <div
    :class="[{
      'StyledBanner': true,
      [`StyledBanner--background-color-${backgroundColour}`]: backgroundColour,
      'StyledBanner--condensed': condensed,
      'StyledBanner--full-width': fullWidth,
      'StyledBanner--external-spacing': externalSpacing,
      'StyledBanner--rounded': bannerStyle === 'generic'
    }, 'ignore-theme']"
  >
    <div :class="fullWidth ? 'global-wrapper' : ''">
      <InfiniteBanner v-if="bannerStyle === 'infinite'" />
      <CarbonNeutralBanner v-if="bannerStyle === 'carbon_neutral_product'" />
      <PrescriptionBanner
        v-if="bannerStyle === 'how_it_works'"
        display-style="row"
        :unpadded="backgroundColour === 'white'"
      />
      <TileTurnaroundBanner v-if="bannerStyle === 'tile_turnaround'" />
      <GenericStyledBanner
        v-if="bannerStyle === 'generic'"
        :image="image"
        :content="content"
        :text-colour="textColour"
      />
      <FebSnowPromo2024
        v-if="bannerStyle === 'feb_snow_promo_24'"
        :image="image"
      />
      <StravaCompetitionBanner
        v-if="bannerStyle === 'strava'"
      />
      <InvestHeroBanner
        v-if="bannerStyle === 'invest_hero'"
        :image="image"
        :mobile-image="mobileImage"
      />
      <MentionMeBanner
        v-if="bannerStyle === 'mention_me'"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StyledBanner',

  props: {
    bannerStyle: {
      type: String,
      validator: val => [
        'carbon_neutral_product',
        'infinite',
        'how_it_works',
        'tile_turnaround',
        'generic',
        'strava',
        'invest_hero',
        'mention_me'
      ].includes(val),
      default: 'carbon_neutral_product'
    },
    backgroundColour: {
      type: String,
      validator: val => ['white', 'light-grey'].includes(val),
      default: 'light-grey'
    },
    condensed: {
      type: Boolean,
      default: false
    },
    image : {
      type: Object,
      default: () => ({})
    },
    mobileImage: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    },
    textColour: {
      type: String,
      validator: val => ['dark', 'light'].includes(val),
      default: 'dark'
    }
  },

  computed: {
    fullWidth () {
      return [
        'carbon_neutral_product',
        'infinite',
        'how_it_works'
      ].includes(this.bannerStyle)
    },
    externalSpacing () {
      return [
        'carbon_neutral_product',
        'infinite',
        'how_it_works'
      ].includes(this.bannerStyle)
    }
  }
}
</script>

<style lang="postcss">
.StyledBanner {
  @apply bg-grey-light
    w-full;

  &--full-width {
    @apply flex-grow w-full;
    margin-left: calc(0px - var(--outer-gutter));
    margin-right: calc(0px - var(--outer-gutter));
  
    @screen xxl {
      margin-left: calc(0px - (((100vw - var(--screen-size)) / 2) + var(--outer-gutter)));
      margin-right: calc(0px - (((100vw - var(--screen-size)) / 2) + var(--outer-gutter)));
    }
  }

  &--external-spacing {
    margin-left: calc(0px - var(--outer-gutter));
    margin-right: calc(0px - var(--outer-gutter));
  
    @screen xxl {
      margin-left: calc(0px - (((100vw - var(--screen-size)) / 2) + var(--outer-gutter)));
      margin-right: calc(0px - (((100vw - var(--screen-size)) / 2) + var(--outer-gutter)));
    }
  }

  &--background-color-white {
    @apply bg-white;
  }

  &--condensed {
    @apply mt-0 pt-0;
  }

  &--rounded {
    @apply rounded-[10px];
  }
}
</style>
